import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import { isEmpty } from 'lodash';

import MenuNav from './menuNav/MenuNav';
import CompanyHeader from './companyHeader/CompanyHeader';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import NotificationsAnchor from 'components/NotificationsAnchor/NotificationsAnchor';
import Login from 'scenes/login/Login';
import Dashboard from 'scenes/dashboard/Dashboard';
import Inventory from 'scenes/inventory/Inventory';
import Campaigns from 'scenes/campaigns/Campaigns';
import NewCampaign from 'scenes/campaigns/NewCampaign/NewCampaign';
import Audiences from 'scenes/audiences/Audiences';
import NewAudience from 'scenes/audiences/NewAudience';
import Template from 'scenes/templates/Templates';
import UsersContainer from 'scenes/users/UsersContainer';
import UsersIndex from 'scenes/users/UsersIndex/UsersIndex';
import InvitationsIndex from 'scenes/users/UsersIndex/InvitationsIndex';
import UserCreation from 'scenes/users/UserCreation/UserCreation';
import UserInvite from 'scenes/users/UserInvite/UserInvite';
import UserDetail from 'scenes/users/UserDetail/UserDetail';
import MyUserDetail from 'scenes/users/MyUserDetail/MyUserDetail';

// import ProfileSettings from 'scenes/profileSettings/ProfileSettings';
// import NotificationSettings from 'scenes/notificationSettings/NotificationSettings';
// import BillingInfoSettings from '../billingInfoSettings/BillingInfoSettings';

import NotFound from 'scenes/notFound/NotFound';
import ResetPassword from '../resetPassword/ResetPassword';
import NewPassword from '../resetPassword/NewPassword';
import TemplateEditor from 'scenes/templateEditor';
// import WizardIntro from 'scenes/wizardIntro';
import Fonts from '../fonts/Fonts';
import Params from 'scenes/Params/Params';
import CreateCompanyParam from 'scenes/Params/CreateCompanyParam';
import AnalyticsDetail from 'scenes/analytics/AnalyticsDetail/AnalyticsDetail';
import Analytics from 'scenes/analytics/Analytics';

import colors from 'theme/Colors.module.scss';
import 'normalize.css';
import './App.scss';
import 'react-day-picker/dist/style.css';

import { Box } from '@chakra-ui/react';

const inEditorStyle = 'inEditor';
const mobileBreakpoint = 1280;

const App = () => {
  // const [requestWizard, setRequestWizard] = React.useState(false);
  const location = useLocation();
  const inTemplateEditor = location.pathname.includes('template-editor');
  // const inCreateConfigParam = location.pathname.match('companyParams/');
  const isResetPassword =
    location.pathname.includes('reset-password') ||
    location.pathname.includes('pw/reset');

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= mobileBreakpoint
  );
  const [mobileMenu, setMobileMenu] = useState(false);

  const [searchLegend, setSearchLegend] = useState(null);

  const indexProps = {
    setSearchLegend,
  };

  const mobileMenuListener = e => {
    const element = e.currentTarget;
    const newWidth = element.innerWidth;
    const mobile = newWidth <= mobileBreakpoint;

    if (mobile !== isMobile) setIsMobile(!isMobile);
  };

  const rightClickListener = e => {
    // e.preventDefault();
    // e.stopPropagation();
  };

  useEffect(() => {
    // Calculate the viewport height and set it as a CSS variable
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // Listen to the resize event and recalculate the viewport height when necessary
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const requestedWizard = localStorage.getItem('requestedWizard');
  //   if (!requestedWizard) {
  //     setRequestWizard(true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    window.addEventListener('resize', e => mobileMenuListener(e));
    return () => {
      window.removeEventListener('resize', e => mobileMenuListener(e));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  useEffect(() => {
    window.addEventListener('contextmenu', e => rightClickListener(e));
    return () => {
      window.removeEventListener('contextmenu', e => rightClickListener(e));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main
      className={`${(inTemplateEditor || isResetPassword) && inEditorStyle}`}
    >
      <section
        id="manu-nav"
        className={`${(inTemplateEditor || isResetPassword) && inEditorStyle} ${
          (mobileMenu || !isMobile) && 'menu-nav__offset'
        }`}
      >
        <MenuNav setMobileMenu={setMobileMenu} />
        <Box
          position={isMobile ? 'absolute' : 'relative'}
          display={isMobile ? 'block' : 'none'}
          right={isMobile ? '1em' : '0'}
          top={isMobile ? '1em' : '0'}
        >
          <i
            className={`fas fa-times hamburger-menu-mobile`}
            onClick={() => setMobileMenu(!mobileMenu)}
          />
        </Box>
      </section>

      {isMobile && !mobileMenu && !inTemplateEditor && !isResetPassword && (
        <i
          className={`fas fa-${mobileMenu ? 'times' : 'bars'} hamburger-menu`}
          style={{
            position: isMobile ? 'absolute' : 'relative',
          }}
          onClick={() => setMobileMenu(!mobileMenu)}
        />
      )}
      {!inTemplateEditor && isMobile && (
        <div
          id="head-content"
          className={`${inTemplateEditor && inEditorStyle} ${
            !inTemplateEditor && mobileMenu
          }`}
        >
          <CompanyHeader
            isMobile={isMobile}
            inTemplateEditor={inTemplateEditor}
          />
        </div>
      )}

      <div
        id="body-content"
        className={`body-content ${inTemplateEditor && inEditorStyle} ${
          !inTemplateEditor && mobileMenu
        }`}
        style={{
          overflow: inTemplateEditor ? 'unset' : 'auto',
          background: colors.coolGrey1,
        }}
      >
        <Routes>
          {/* {(token && requestWizard) && <WizardIntro setRequestWizard={setRequestWizard}/>} */}
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/pw/reset" element={<NewPassword />} />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isMobile={isMobile} element={<Dashboard />} />
            }
          />

          {/* Analytics */}
          <Route
            path="/analytics"
            element={
              <PrivateRoute isMobile={isMobile} element={<Analytics />} />
            }
          />
          <Route
            path="/analytics/:id"
            element={
              <PrivateRoute isMobile={isMobile} element={<AnalyticsDetail />} />
            }
          />

          {/* Campaigns */}
          <Route
            path="/campaigns"
            element={
              <PrivateRoute isMobile={isMobile} element={<Campaigns />} />
            }
          />
          <Route
            path="/campaigns/:id"
            element={<PrivateRoute element={<NewCampaign />} />}
          />
          <Route
            path="/campaigns/new"
            element={<PrivateRoute element={<NewCampaign />} />}
          />

          {/* Templates */}
          <Route
            path="/templates"
            element={
              <PrivateRoute isMobile={isMobile} element={<Template />} />
            }
          />
          <Route
            path="/template-editor"
            element={
              <PrivateRoute
                isMobile={isMobile}
                inEditorStyle={inEditorStyle}
                element={<TemplateEditor />}
              />
            }
          />

          {/* Audiences */}
          <Route
            path="/audiences"
            element={
              <PrivateRoute isMobile={isMobile} element={<Audiences />} />
            }
          />
          <Route
            path="/audiences/:id"
            element={<PrivateRoute element={<NewAudience />} />}
          />
          <Route
            path="/audiences/new"
            element={<PrivateRoute element={<NewAudience />} />}
          />

          {/* Inventory */}
          <Route
            path="/inventory"
            element={<PrivateRoute element={<Inventory />} />}
          />

          {/* Users */}
          <Route
            path="/users"
            element={<UsersContainer searchLegend={searchLegend} />}
          >
            <Route
              index
              element={
                <PrivateRoute element={<UsersIndex {...indexProps} />} />
              }
            />
            <Route
              path="invited"
              element={
                <PrivateRoute element={<InvitationsIndex {...indexProps} />} />
              }
            />
          </Route>
          <Route
            path="/users/:id"
            element={<PrivateRoute element={<UserDetail />} />}
          />
          <Route
            path="/users/new"
            element={<PrivateRoute element={<UserCreation />} />}
          />
          <Route
            path="/users/invite"
            element={<PrivateRoute element={<UserInvite />} />}
          />
          <Route
            path="/user/me"
            element={<PrivateRoute element={<MyUserDetail />} />}
          />

          {/* Fonts */}
          <Route path="/fonts" element={<PrivateRoute element={<Fonts />} />} />

          {/* Company Params */}
          <Route
            path="/companyParams"
            element={<PrivateRoute element={<Params />} />}
          />
          <Route
            path="/companyParams/:id"
            element={<PrivateRoute element={<CreateCompanyParam />} />}
          />
          <Route
            path="/companyParams/create"
            element={<PrivateRoute element={<CreateCompanyParam />} />}
          />

          {/* Settings */}
          {/* <PrivateRoute
            authed={!isEmpty(token)}
            path="/profile"
            element={<ProfileSettings />}
          /> */}
          {/* <PrivateRoute
            authed={!isEmpty(token)}
            path="/notifications"
            element={<NotificationSettings />}
          /> */}
          {/* <PrivateRoute
            authed={!isEmpty(token)}
            path="/billing-info"
            element={<BillingInfoSettings />}
          /> */}

          {/* Recirects */}
          <Route path="/" element={<Navigate to="/dashboard" />} />

          {/* 404 -- Unknown Routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <NotificationsAnchor />
      </div>
    </main>
  );
};

export default App;
